import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Star, Sparkles } from 'lucide-react';
import { PawBackground } from './PawBackground';
export function Hero() {
  return <section className="relative pt-24 pb-20 md:pt-48 md:pb-32 overflow-hidden" data-id="element-97">
      {/* Twinkling paw prints */}
      <PawBackground data-id="element-98" />

      {/* Decorative background blobs */}
      <div className="absolute top-20 left-[-10%] w-[40rem] h-[40rem] bg-coral/20 blob-shape -z-10 blur-3xl" data-id="element-99" />
      <div className="absolute bottom-[-10%] right-[-5%] w-[35rem] h-[35rem] bg-lavender/20 blob-shape -z-10 blur-3xl" style={{
      animationDelay: '-4s'
    }} data-id="element-100" />

      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-xl order-2 md:order-1" data-id="element-102">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-warmBrown leading-[1.1] mb-6" data-id="element-103">
            Your pet. <br data-id="element-104" />
            <span className="text-peach" data-id="element-105">Your self-care buddy.</span>
          </h1>

          <p className="text-lg md:text-xl text-warmBrown/80 mb-8 leading-relaxed" data-id="element-106">
            Turn your real pet into a cute digital companion. Keep them happy by
            completing daily habits, tracking your mood, and taking moments to
            breathe. Take care of yourself — together.
          </p>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-3" data-id="element-107">
            <motion.a href="https://apps.apple.com/us/app/pawchi-self-care-pet/id6764858701" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-block" aria-label="Download on the App Store" data-id="element-108">
              <img src="https://cdn.magicpatterns.com/uploads/bgW7hVXTEHmConMeGXzro4/app-store.svg" alt="Download on the App Store" className="h-[52px] w-auto" data-id="element-109" />
            </motion.a>
            <motion.a href="https://play.google.com/store/apps/details?id=app.pawchi.mobile" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-block -ml-3 sm:ml-0" aria-label="Get it on Google Play" data-id="element-110">
              <img src="https://cdn.magicpatterns.com/uploads/omQrJZxYBdQEgWZzBHqrye/play-store.png" alt="Get it on Google Play" className="h-[76px] w-auto -my-3" data-id="element-111" />
            </motion.a>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative h-[380px] md:h-[600px] flex justify-center items-center order-1 md:order-2 mt-8 md:mt-0" data-id="element-112">
          {/* Floating elements */}
          <motion.div animate={{
          y: [-10, 10, -10]
        }} transition={{
          repeat: Infinity,
          duration: 4,
          ease: 'easeInOut'
        }} className="absolute top-20 left-10 text-peach" data-id="element-113">
            <Heart size={32} fill="currentColor" data-id="element-114" />
          </motion.div>
          <motion.div animate={{
          y: [10, -10, 10]
        }} transition={{
          repeat: Infinity,
          duration: 5,
          ease: 'easeInOut',
          delay: 1
        }} className="absolute bottom-32 right-10 text-lavender" data-id="element-115">
            <Star size={40} fill="currentColor" data-id="element-116" />
          </motion.div>
          <motion.div animate={{
          y: [-15, 15, -15],
          rotate: [0, 10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut',
          delay: 2
        }} className="absolute top-40 right-20 text-4xl" data-id="element-117">
            🐾
          </motion.div>

          {/* Phone Mockup */}
          <div className="relative z-[2] w-[220px] h-[440px] md:w-[300px] md:h-[600px] bg-warmBrown rounded-[2.2rem] md:rounded-[3rem] shadow-soft-lg border-[3px] border-warmBrown/20 p-[4px] md:p-[6px] overflow-hidden" data-id="element-118">
            {/* Video */}
            <video src="https://cdn.magicpatterns.com/uploads/uZzShn8uwKzbfKBmC7H8k2/Matte_2026-05-18_17-03-43.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover rounded-[2.6rem]" data-id="element-119" />
          </div>
        </motion.div>
      </div>
    </section>;
}